<template>
    <div class="password-input">
        <input
            v-model="pass"
            :type="type"
            :placeholder="placeholder"
            class="password"
            autocomplete="off"
            @input="handleInput"
            @blur="regPassword"
        />
        <span :class="[{ visible: isVisibility }, 'visibility']" @click="changeVisibility"></span>
    </div>
</template>

<script>
export default {
    name: 'HkPasswordInput',
    props: {
        value: {
            type: String
        },
        placeholder: {
            type: String
        },
        reg: {
            type: RegExp
        }
    },
    data() {
        return {
            type: 'password',
            pass: '',
            isVisibility: false
        };
    },
    methods: {
        changeVisibility() {
            if (!this.isVisibility) {
                this.type = 'text';
                this.isVisibility = true;
            } else {
                this.type = 'password';
                this.isVisibility = false;
            }
        },
        handleInput() {
            this.$emit('input', this.pass);
        },
        regPassword() {
            if (this.reg) {
                if (!this.reg.test(this.pass)) {
                    this.$message.error('请设置8位以上的数字、字母组合密码');
                }
            }
            this.$emit('blur');
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.password-input {
    width: 100%;
    position: relative;
    .password {
        box-sizing: border-box;
        width: 100%;
        height: 46px;
        background: #f4f4f4;
        border: none;
        outline: none;
        margin-bottom: 26px;
        color: #a0a0a0;
        font-size: 14px;
        padding: 0 60px 0 20px;
    }
    .visibility {
        position: absolute;
        top: 16px;
        right: 20px;
        width: 20px;
        height: 14px;
        background: url('~@images/base/invisible-icon.png') no-repeat center;
        cursor: pointer;
    }
    .visible {
        background-image: url('~@images/base/visible-icon.png');
    }
}
</style>
